import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=acb0e316&scoped=true"
import script from "./UserHeader.vue?vue&type=script&lang=js"
export * from "./UserHeader.vue?vue&type=script&lang=js"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=acb0e316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0e316",
  null
  
)

export default component.exports